
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import i06 from "../../img/1280/16x9/Instagram_Login.png"

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Image = makeShortcode("Image");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={i06} mdxType="Image" />
    <h1>{`Login's`}</h1>
    <p>{`Der Nutzername war bella_wgnrm... und wie war nochmal das Passwort?`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;